export const WA_NUMBER = "966593777448";
export const getWaLink = (msg: string) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WA_MESSAGES = {
  hero: "السلام عليكم، مهتم بقهوة الجملة من جوفريز وأرغب باستلام كتالوج الأسعار",
  catalog: "أهلاً، أرغب باستلام كتالوج جوفريز للجملة",
  sample: (cat: string) => `أهلاً، أرغب بطلب عينة ${cat}`,
  starter: 'أهلاً، مهتم بـ "باقة الانطلاق"',
  pro: 'أهلاً، مهتم بـ "باقة المحترف"',
  chain: 'أهلاً، مهتم بـ "باقة السلسلة"',
  final: "السلام عليكم، جاهز أبدأ شراكة الجملة مع جوفريز",
  floating: "السلام عليكم، عندي استفسار عن جملة جوفريز",
};
